import React from 'react';

export const ugroupOptionRenderer = ugroup => `${ugroup.id} • ${ugroup.name}`;
